// 圈速表的列配置
export const sportColumnKeys = {
  // 户外跑
  Run: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Ground_Time', config: { status: false } },
    { key: 'L_R_Balance', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Max_Cadence', config: { status: false } },
    { key: 'Stride_Ratio', config: { status: false } },
    { key: 'Stride_Height', config: { status: false } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Form_Power', config: { status: false } },
    { key: 'Leg_Stiffness', config: { status: false } },
    // { key: 'Landing_Angle', config: { status: false } },
    // { key: 'Vertical_Ground_Reaction_Force', config: { status: false } },
    { key: 'Elev_Gain', config: { status: false } },
    { key: 'Total_Descent', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Adjusted_Pace', config: { status: true } },
    { key: 'StandardRate', config: { status: true } }
  ],
  // 跑步机
  Indoor_Run: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Ground_Time', config: { status: false } },
    { key: 'L_R_Balance', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Max_Cadence', config: { status: false } },
    { key: 'Stride_Ratio', config: { status: false } },
    { key: 'Stride_Height', config: { status: false } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Form_Power', config: { status: false } },
    { key: 'Leg_Stiffness', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } }
  ],
  // 越野跑
  Trail_Run: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Ground_Time', config: { status: false } },
    { key: 'L_R_Balance', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Max_Cadence', config: { status: false } },
    { key: 'Stride_Ratio', config: { status: false } },
    { key: 'Stride_Height', config: { status: false } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Form_Power', config: { status: false } },
    { key: 'Leg_Stiffness', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Adjusted_Pace', config: { status: true } },
    { key: 'StandardRate', config: { status: true } }
  ],
  // 操场跑圈
  Track_Run: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Ground_Time', config: { status: false } },
    { key: 'L_R_Balance', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Max_Cadence', config: { status: false } },
    { key: 'Stride_Ratio', config: { status: false } },
    { key: 'Stride_Height', config: { status: false } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Form_Power', config: { status: false } },
    { key: 'Leg_Stiffness', config: { status: false } },
    { key: 'Elev_Gain', config: { status: false } },
    { key: 'Total_Descent', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } }
  ],
  // 徒步
  Hike: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: false } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Max_Cadence', config: { status: false } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } }
  ],
  // 登山
  Mtn_Climb: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: false } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Vert_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Max_Cadence', config: { status: false } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 骑行
  Bike: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'NP', config: { status: false } },
    { key: 'Avg_Cadence', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } },
    { key: 'L_R_Balance', config: { status: true } }
  ],
  // 头盔骑行
  Helmet_Bike: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'NP', config: { status: false } },
    { key: 'Avg_Cadence', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } },
    { key: 'L_R_Balance', config: { status: false } }
  ],
  // 室内骑行
  Indoor_Bike: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'NP', config: { status: false } },
    { key: 'Avg_Cadence', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } },
    { key: 'L_R_Balance', config: { status: false } }
  ],
  // 公路 e-bike
  Road_Ebike: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'NP', config: { status: false } },
    { key: 'Avg_Cadence', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } },
    { key: 'L_R_Balance', config: { status: false } }
  ],
  // 砾石路骑行
  Gravel_Road_Bike: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'NP', config: { status: false } },
    { key: 'Avg_Cadence', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } },
    { key: 'L_R_Balance', config: { status: false } }
  ],
  // 山地骑行
  Mountain_Riding: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'NP', config: { status: false } },
    { key: 'Avg_Cadence', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } },
    { key: 'L_R_Balance', config: { status: false } }
  ],
  // 山地 e-bike
  Mountain_Ebike: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'NP', config: { status: false } },
    { key: 'Avg_Cadence', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } },
    { key: 'L_R_Balance', config: { status: false } }
  ],
  // 泳池游泳
  Pool_Swim: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    // { key: 'XMode', config: { status: true } },
    // { key: 'StartTime', config: { status: true } },
    // { key: 'EndTime', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Swim_Stroke_Rate', config: { status: true } },
    { key: 'Strokes', config: { status: true } },
    { key: 'SWOLF', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Water_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } }
  ],
  // 公开水域
  Open_Water: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Swim_Stroke_Rate', config: { status: true } },
    { key: 'Strokes', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Water_Temperature', config: { status: false } }
  ],
  // 铁三
  Triathlon: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Activity_Name', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 健身 402
  Strength: [
    { key: 'Left_Gap', config: { status: true } },
    // { key: 'Number', config: { status: true } },
    { key: 'Action_Name', config: { status: true } },
    { key: 'Sets', config: { status: true } },
    { key: 'Reps', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: false } },
    { key: 'weight', config: { status: true } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Calories', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'StandardRate', config: { status: true } }
  ],
  // 室内有氧
  Gym_Cardio: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 户外有氧
  GPS_Cardio: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: false } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Elev_Gain', config: { status: false } },
    { key: 'Total_Descent', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 雪场双板
  Ski: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Downhill_Dist', config: { status: true } },
    { key: 'Downhill_Time', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: true } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Downhill_Desc', config: { status: true } },
    { key: 'Grade', config: { status: true } },
    { key: 'Max_Grade', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 雪场单板
  Snowboard: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Downhill_Dist', config: { status: true } },
    { key: 'Downhill_Time', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: true } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Downhill_Desc', config: { status: true } },
    { key: 'Grade', config: { status: true } },
    { key: 'Max_Grade', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 越野滑雪
  XC_Ski: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: true } },
    { key: 'Vert_Speed', config: { status: false } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Max_Cadence', config: { status: false } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Grade', config: { status: false } },
    { key: 'Max_Grade', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Adjusted_Speed', config: { status: true } }
  ],
  // 登山滑雪
  Ski_Touring: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Activity_Name', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: true } },
    { key: 'Vert_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Avg_Step_Cadence', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Grade', config: { status: false } },
    { key: 'Max_Grade', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Adjusted_Speed', config: { status: true } }
  ],
  // 登山滑雪
  Ski_Touring_Old: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Activity_Name', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 组合运动
  Multi_Sport: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Activity_Name', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 竞速帆板
  Speedsurfing: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 帆板
  Windsurfing: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: false } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 赛艇
  Row: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Row_Stroke_Rate', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 划船机
  Indoor_Row: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: false } },
    { key: 'Avg_Power', config: { status: false } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Row_Stroke_Rate', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 激流运动
  Whitewater: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Row_Stroke_Rate', config: { status: true } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 静水运动
  Flatwater: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: false } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Row_Stroke_Rate', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 多段攀登
  Multi_Pitch: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Activity_Name', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 攀登
  Climb: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Pitches', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Hardest_Grade', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Vert_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Elev_Gain', config: { status: false } },
    { key: 'Total_Descent', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 健走
  Walk: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Distance', config: { status: true } },
    { key: 'Steps', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Pace', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Avg_Step_Cadence', config: { status: true } },
    { key: 'Avg_Stride_Length', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } }
  ],
  // 跳绳
  Jump_Rope: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Jump_Rope_Lengths', config: { status: true } },
    { key: 'Reps', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_Speed', config: { status: true } },
    { key: 'Max_Speed', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Calories', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Max_Cont_Jumps', config: { status: true } },
    { key: 'Stumble_Rope', config: { status: true } }
  ],
  // 室内攀岩 sportType: 800
  IndoorClimb: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Routes', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'RecoverTime', config: { status: true } },
    // 攀岩数据不显示累计时间数据项
    // { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Hardest_Grade', config: { status: true } },
    { key: 'Style', config: { status: true } },
    { key: 'Falls', config: { status: true } },
    { key: 'MaxActivityFall', config: { status: true } },
    { key: 'Total_Ascent', config: { status: true } }
  ],
  // 抱石 sportType: 801
  Bouldering: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Routes', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'RecoverTime', config: { status: true } },
    // 攀岩数据不显示累计时间数据项
    // { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Body_Temperature', config: { status: false } },
    { key: 'Hardest_Grade', config: { status: true } },
    { key: 'Style', config: { status: true } },
    { key: 'Total_Ascent', config: { status: true } }
  ],
  // 爬楼 sportType: 902
  Climb_Stairs: [
    { key: 'Left_Gap', config: { status: true } },
    { key: 'Laps_Lengths', config: { status: true } },
    { key: 'Climb_Stairs_Floors', config: { status: true } },
    { key: 'Time', config: { status: true } },
    { key: 'Total_Length', config: { status: true } },
    { key: 'Avg_HR', config: { status: true } },
    { key: 'Max_HR', config: { status: false } },
    { key: 'Elev_Gain', config: { status: true } },
    { key: 'Total_Descent', config: { status: true } }
  ]
};
